export default __webpack_public_path__ + "static/media/2SiteCooperando_Desktop_VetorMindMap.9b9c2f64.png";